import React from 'react';
import { TagColor, MktTag } from './Tag';
import clsx from 'clsx';

interface TagPropInterface {
  children: string;
  color?: `${TagColor}`;
}

interface MktMarketCardProps {
  tags?: TagPropInterface[];
  title: string;
  subtitle: string;
  description?: string;
  tableValues: { key: string; value: string; link?: string }[];
  logo: string;
  backgroundImage?: string;
}

export const MktMarketCard: React.FC<MktMarketCardProps> = ({
  tags,
  title,
  subtitle,
  description,
  tableValues,
  logo,
  backgroundImage,
}) => {
  return (
    <div className="wh-w-full wh-block md:wh-w-[339px]  wh-min-h-[422px] wh-rounded-lg wh-overflow-hidden wh-shadow-md 2xl:wh-w-[428px] hover:wh-shadow-lg wh-transition-all">
      <div
        className={clsx(
          'wh-w-full wh-h-[111px] wh-flex wh-justify-start wh-items-center wh-p-4 2xl:wh-p-5 wh-relative',
          `${backgroundImage ? 'wh-bg-[transparent]' : 'wh-bg-gold'}`,
        )}
      >
        {backgroundImage && (
          <img
            alt={title}
            src={backgroundImage}
            className="wh-absolute wh-w-full wh-h-full wh-top-0 wh-left-0 wh-z-0 wh-rounded-t-lg"
          />
        )}
        <img
          className="wh-block wh-w-auto wh-max-w-[192px] wh-h-[33px] 2xl:wh-max-w-[253px] 2xl:wh-h-[39px] wh-z-10 wh-object-contain wh-relative"
          src={logo}
          alt={title}
        />
      </div>
      <div className="wh-pt-3 wh-px-3 wh-pb-4 2xl:wh-pt-4 2xl:wh-px-5 2xl:wh-pb-5 wh-flex wh-flex-col wh-gap-3 wh-bg-white ">
        {tags && (
          <div className="wh-flex wh-gap-[10px]">
            {tags.map(({ children, color }, i) => {
              return (
                <MktTag key={i} color={color}>
                  {children}
                </MktTag>
              );
            })}
          </div>
        )}
        <div className=" wh-flex wh-flex-col wh-gap-2">
          <p className="wh-text-gold wh-text-xs wh-font-bold wh-tracking-[0.48px] wh-uppercase">
            {title}
          </p>
          <p className="wh-text-grey wh-text-base wh-font-medium wh-tracking-[0.32px] wh-leading-5  wh-h-[40px] wh-line-clamp-2">
            {subtitle}
          </p>
          {description && (
            <p className="wh-text-grey wh-text-sm wh-tracking-[0.14px] wh-leading-4">
              {description}
            </p>
          )}
          <div className="wh-mt-1">
            {tableValues.map((value, i: number) => {
              return (
                <div
                  key={i}
                  className={clsx(
                    'wh-flex wh-justify-between',
                    'wh-py-[4px]',
                    `${
                      i + 1 !== tableValues.length
                        ? 'wh-border-b-[1px] wh-border-gold'
                        : 'wh-border-none'
                    }`,
                  )}
                >
                  <div className="wh-w-1/2 wh-text-sm wh-tracking-[0.14px] wh-text-grey">
                    <p>{value.key}</p>
                  </div>
                  <div className="wh-w-1/2 wh-text-sm wh-font-bold wh-tracking-[0.14px] wh-text-grey">
                    {value.link ? (
                      <button
                        onClick={evt => {
                          evt.preventDefault();
                          return window.open(value.link, '_blank');
                        }}
                        className="wh-text-blue-light wh-underline"
                        type="button"
                      >
                        {value.value}
                      </button>
                    ) : (
                      <p>{value.value}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
